import { useNavigate, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import {
  Page,
  H1,
  P,
  Button,
  Box,
  Card,
  CardContent,
  Stack,
} from '../components';
import { Person, ChildCare } from '@mui/icons-material';

const LoginPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, userType } = useAuth();

  const from = location.state?.from?.pathname || '/';

  useEffect(() => {
    // If user is already authenticated, redirect to appropriate page
    if (user) {
      if (userType === 'guardian') {
        navigate('/guardian', { replace: true });
      } else if (userType === 'child') {
        navigate('/play', { replace: true });
      } else {
        navigate(from, { replace: true });
      }
    }
  }, [user, userType, navigate, from]);

  const handleGuardianLogin = () => {
    navigate('/login/guardian');
  };

  const handleChildrenLogin = () => {
    navigate('/login/children');
  };

  return (
    <Page maxWidth="sm" fullHeight>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        minHeight="80vh"
        gap={3}
      >
        <H1>Welcome to Learndle</H1>
        <P color="text.secondary" sx={{ textAlign: 'center', mb: 2 }}>
          Choose your login option to get started
        </P>

        <Stack spacing={3} width="100%" maxWidth={400}>
          <Card elevation={2}>
            <CardContent sx={{ p: 3 }}>
              <Box textAlign="center">
                <Person
                  sx={{
                    fontSize: 48,
                    color: 'primary.main',
                    mb: 2,
                  }}
                />
                <H1 variant="h5" gutterBottom>
                  Guardians
                </H1>
                <P color="text.secondary" sx={{ mb: 3 }}>
                  Parents and guardians can manage their children&apos;s
                  learning experience
                </P>
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  fullWidth
                  onClick={handleGuardianLogin}
                >
                  Guardian Login
                </Button>
              </Box>
            </CardContent>
          </Card>

          <Card elevation={2}>
            <CardContent sx={{ p: 3 }}>
              <Box textAlign="center">
                <ChildCare
                  sx={{
                    fontSize: 48,
                    color: 'secondary.main',
                    mb: 2,
                  }}
                />
                <H1 variant="h5" gutterBottom>
                  Children
                </H1>
                <P color="text.secondary" sx={{ mb: 3 }}>
                  Kids can access their learning activities and games
                </P>
                <Button
                  variant="contained"
                  color="secondary"
                  size="large"
                  fullWidth
                  onClick={handleChildrenLogin}
                >
                  Children Login
                </Button>
              </Box>
            </CardContent>
          </Card>
        </Stack>
      </Box>
    </Page>
  );
};

export default LoginPage;
